"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCheckbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = require("react-tracking");

var _stitches = require("../../../stitches.config");

var StyledCheckboxWrapper = (0, _stitches.styled)('div', {
  alignItems: 'center',
  display: 'flex',
  position: 'relative'
});
var StyledCheckbox = (0, _stitches.styled)('input', {
  appearance: 'none',
  border: '1px solid $black',
  borderRadius: '5px',
  cursor: 'pointer',
  height: '20px',
  marginRight: '10px',
  position: 'relative',
  minWidth: '20px',
  '&:focus': {
    outlineColor: '$secondary',
    outlineStyle: 'solid',
    outlineWidth: '2px'
  },
  '&:checked': {
    border: 'none',
    '&:focus': {
      outlineColor: '$black',
      outlineStyle: 'solid',
      outlineWidth: '2px'
    },
    '&::after': {
      backgroundColor: '$secondary',
      borderColor: '$secondary',
      borderRadius: '5px',
      content: "'\\2714\\fe0e'",
      // eslint-disable-line quotes
      color: '$white',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: '$large',
      height: '18px',
      left: '1px',
      lineHeight: '100%',
      position: 'absolute',
      textAlign: 'center',
      top: '0.5px',
      width: '18px'
    }
  }
});
exports.StyledCheckbox = StyledCheckbox;
var StyledDescription = (0, _stitches.styled)('label', {
  fontSize: '$small',
  '&:hover': {
    cursor: 'pointer'
  }
});
/**
 * Simple checkbox with a description that allows for prechecking.
 */

var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      id = _ref.id,
      name = _ref.name;

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var handleToggleChecked = function handleToggleChecked(_ref2) {
    var checked = _ref2.target.checked;
    trackEvent({
      event_name: name,
      event_type: checked ? 'checked' : 'unchecked'
    });
  };

  return /*#__PURE__*/_react.default.createElement(StyledCheckboxWrapper, null, /*#__PURE__*/_react.default.createElement(StyledCheckbox, {
    id: id,
    name: name,
    ref: ref,
    type: "checkbox",
    onChange: handleToggleChecked
  }), /*#__PURE__*/_react.default.createElement(StyledDescription, {
    htmlFor: id
  }, children));
});
Checkbox.defaultProps = {};
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports.default = _default;